import { defineNuxtPlugin, useRuntimeConfig } from '#app';
import posthog from 'posthog-js';

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const posthogApiKey = config.public.posthogApiKey || '';
  const posthogHost = config.public.posthogHost || 'https://us.i.posthog.com';

  // Only initialize if API key is present
  if (posthogApiKey) {
    posthog.init(posthogApiKey, {
      api_host: posthogHost,
      capture_pageview: false, // We'll handle this manually for more control
      bootstrap: {
        distinctID: null, // Will be set on user login
        properties: {
          environment: config.public.environment || 'development',
          app_version: config.public.appVersion || '1.0.0',
        },
      },
      // No debug logging
    });
  }

  // Make PostHog available throughout the app
  nuxtApp.provide('posthog', posthog);

  // PostHog is now properly configured
});
